{
  "it": {
    "question": {
      "actions": {
        "addDocuments": "Aggiungi documenti",
        "cancel": "Annulla",
        "createQuestion": "Crea domanda",
        "delete": "Elimina",
        "deleteDocuments": "Elimina documenti",
        "edit": "Modifica",
        "moveDown": "Sposta giù",
        "moveUp": "Sposta su",
        "new": "Domanda",
        "save": "Salva"
      },
      "attributes": {
        "answer": "Risposta",
        "documents": "Documenti / Immagini",
        "name": "Domanda",
        "question": "Domanda"
      },
      "labels": {
        "editQuestion": "Modifica domanda",
        "newQuestion": "Nuova domanda"
      },
      "toasts": {
        "create": "Domanda creata",
        "delete": "Domanda eliminata",
        "update": "Domanda aggiornata"
      },
      "validation": {
        "needAnswer": "Risposta obbligatoria",
        "needQuestion": "Domanda obbligatoria"
      }
    }
  }
}
